import { useMemo } from 'react'
import { useMindMapContext } from '../../../../context/mindmap'
import { SelectionBanner } from '../../../../features/report'
import { useReportSidebar } from './useReportSidebar'

export function ExportSelectionBanner() {
  const { selectedNodeIds, changeSelection } = useReportSidebar()
  const { nodes } = useMindMapContext()

  const categoryCounts = useMemo(() => {
    const counts = new Map<string, number>()
    if (!selectedNodeIds) return counts

    for (const nodeId of selectedNodeIds) {
      const node = nodes.find((n) => n.id === nodeId)
      if (!node) continue
      const category = node.data.category
      counts.set(category, (counts.get(category) ?? 0) + 1)
    }
    return counts
  }, [selectedNodeIds, nodes])

  if (!selectedNodeIds) return null

  return <SelectionBanner categoryCounts={categoryCounts} onChangeSelection={changeSelection} />
}
